export const styles = {
  global: {
    "input, select, textarea": {
      fontSize: "16px !important",
    },
  },
};

export const colors = {
  brand: {
    DEFAULT: "#AD31C1",
    50: "#E7BCEE",
    100: "#E1ABEA",
    200: "#D58BE2",
    300: "#CA6AD9",
    400: "#BE4AD1",
    500: "#AD31C1",
    600: "#852694",
    700: "#5D1A68",
    800: "#350F3B",
    900: "#0D040E",
    950: "#000000",
  },
  secondary: {
    50: "#F8FCFC",
    100: "#EBF5F5",
    200: "#CFE8E8",
    300: "#A9D6D6",
    400: "#83C4C4",
    500: "#5DB1B1",
    600: "#469191",
    700: "#336B6B",
    800: "#214545",
    900: "#0F1F1F",
    950: "#060C0C",
  },
};

export const fonts = {
  body: `'Inter', sans-serif`,
};
